export default __webpack_public_path__ + "static/media/HRM.4ff66590.svg";